import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isBuffetOpen, setIsBuffetOpen] = useState(false);
  const [isArcadeOpen, setIsArcadeOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const headerRef = useRef(null);

  const toggleMobileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setShowMobileMenu(false);
      }
    };

    if (showMobileMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMobileMenu]);

  return (
    <header
      ref={headerRef}
      className={`site-header ${scrolled ? "shrink" : ""}`}
    >
      <div className="header-inner">
        {/* Left Navigation */}
        <nav className={`nav-left ${showMobileMenu ? "show" : ""}`}>
          <div
            className="dropdown"
            onMouseEnter={() => setIsBuffetOpen(true)}
            onMouseLeave={() => setIsBuffetOpen(false)}
          >
            <button className="nav-button">Buffet</button>

            <div className={`dropdown-content ${isBuffetOpen ? "open" : ""}`}>
              <Link to="/buffet-pricing">Pricing</Link>

              <Link to="/drinks">Drinks</Link>
            </div>
          </div>

          <Link to="/gallery">Gallery</Link>
        </nav>

        {/* Center Logo */}
        <Link to="/" className="logo-link">
          HIRO
        </Link>

        {/* Right Navigation */}
        <nav className={`nav-right ${showMobileMenu ? "show" : ""}`}>
          <div
            className="dropdown"
            onMouseEnter={() => setIsArcadeOpen(true)}
            onMouseLeave={() => setIsArcadeOpen(false)}
          >
            {/* NO LINK */}
            <button className="nav-button arcade-disabled">Arcade</button>

            {/* COMING SOON DROPDOWN */}
            <div
              className={`dropdown-content arcade-coming ${
                isArcadeOpen ? "open" : ""
              }`}
            >
              <span className="coming-soon-text">🎮 Arcade Coming Soon</span>
            </div>
          </div>

          <Link to="/address">Location</Link>
        </nav>

        {/* Mobile Button */}
        <button
          className="hamburger"
          onClick={toggleMobileMenu}
          aria-label="Toggle Menu"
          aria-expanded={showMobileMenu}
        >
          ☰
        </button>
      </div>

      {/* Mobile Navigation */}
      <div className={`mobile-menu ${showMobileMenu ? "show" : ""}`}>
        <Link to="/buffet-pricing" onClick={() => setShowMobileMenu(false)}>
          Buffet Pricing
        </Link>

        <Link to="/drinks" onClick={() => setShowMobileMenu(false)}>
          Drinks
        </Link>

        <Link to="/gallery" onClick={() => setShowMobileMenu(false)}>
          Gallery
        </Link>

        <Link to="/address" onClick={() => setShowMobileMenu(false)}>
          Location
        </Link>
      </div>
    </header>
  );
};

export default Header;
